/**
 * Geo-based setting to determine when we should add credit cards via Adyen
 */
export const USE_ADYEN_FOR_RETAILER_PAYMENTS = 'USE_ADYEN_FOR_RETAILER_PAYMENTS';
